//@flow

import React, { Fragment, useState } from 'react';
import type { FormikProps } from 'formik';
import { connect as formikConnect } from 'formik';
import { FormGroup, InputGroup, Label, InputGroupAddon, Input, Button } from 'reactstrap';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { getCustomToast } from '../ErrorMessage';

type Props = {
  formik: FormikProps,
  onSuccess: () => void,
  hideLabel: boolean,
};

function PromoCode({ formik, onSuccess, hideLabel = false }: Props) {
  const { values, setValues: onChange } = formik;
  const { discount, promocode } = values;
  const [isLoading, setLoading] = useState(false);

  const isCodeApplied = Boolean(discount);
  return (
    <FormGroup>
      {isCodeApplied ? (
        <Fragment>
          <span>
            Promo code <strong>{promocode}</strong> applied
          </span>
          <hr />
          <Button
            color="primary"
            size="sm"
            onClick={() => onChange({ ...values, discount: null, promocode: null })}
          >
            Cancel Promo code
          </Button>
        </Fragment>
      ) : (
        <Fragment>
          <Label className={hideLabel ? 'sr-only' : ''}>Enter Promo Code</Label>
          <InputGroup>
            <Input
              type="text"
              value={promocode}
              onChange={e => onChange({ ...values, promocode: e.target.value })}
            />
            <InputGroupAddon addonType="append" className="promo">
              <Button
                className={isLoading ? 'btn-loading' : ''}
                color="yellow"
                onClick={validatePromoCode}
                disabled={!promocode}
              >
                {isLoading ? 'APPLYING CODE' : 'APPLY CODE'}
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </Fragment>
      )}
    </FormGroup>
  );

  async function validatePromoCode() {
    setLoading(true);

    try {
      const { data } = await api.postWithoutToken(endpoints.promoCode.getDiscount, {
        promocode,
      });

      onChange({ ...values, discount: data.discount });
      onSuccess();
    } catch (e) {
      getCustomToast(
        e.response ? e.response.data.message.msg : 'Please Enter A Valid Promo Code.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  }
}

PromoCode.defaultProps = {
  onSuccess: () => {},
};

export default formikConnect(PromoCode);



// WEBPACK FOOTER //
// ./src/components/PromoCode/PromoCode.jsx